import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEMarineCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Marine Engineering",
    shortName: "B.E. Marine",
    duration: "4 years",
    description: "Engineering program focused on design, operation, and maintenance of marine vessels and offshore structures",
    overview: "Bachelor of Engineering in Marine Engineering (B.E. Marine) is a 4-year undergraduate program that deals with the engineering aspects of ships, boats, and other marine vessels. This course covers marine propulsion systems, ship design, naval architecture, offshore engineering, and maritime safety, preparing students for careers in shipping, shipbuilding, and offshore industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Medical fitness for sea service (if pursuing marine career)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Workshop Technology",
          "Naval Architecture Basics"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Fluid Mechanics",
          "Materials Science",
          "Ship Construction",
          "Marine Engineering Drawing"
        ]
      },
      {
        year: 3,
        subjects: [
          "Marine Propulsion Systems",
          "Ship Stability and Design",
          "Marine Power Plant",
          "Marine Electrical Systems",
          "Ocean Engineering",
          "Maritime Safety"
        ]
      },
      {
        year: 4,
        subjects: [
          "Offshore Engineering",
          "Ship Maintenance and Repair",
          "Marine Instrumentation",
          "Environmental Marine Engineering",
          "Project Work",
          "Industry Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Marine Engineer",
        "Naval Architect",
        "Ship Designer",
        "Port Engineer",
        "Offshore Engineer",
        "Marine Surveyor",
        "Technical Superintendent",
        "Marine Consultant"
      ],
      industries: [
        "Shipping Companies",
        "Shipbuilding Yards",
        "Port Authorities",
        "Offshore Oil & Gas",
        "Marine Insurance",
        "Classification Societies",
        "Government Maritime Departments",
        "Research Institutions"
      ],
      averageSalary: "₹6-12 LPA (Shore-based), ₹15-40 LPA (Sea-going)",
      topRecruiters: [
        "Shipping Corporation of India",
        "Larsen & Toubro Shipbuilding",
        "Cochin Shipyard",
        "Oil and Natural Gas Corporation",
        "Great Eastern Shipping",
        "Mazagon Dock Shipbuilders"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for maritime universities)",
      "State-level entrance exams",
      "Direct admission to maritime institutes",
      "Management quota admissions"
    ],

    topColleges: [
      {
        name: "Indian Maritime University",
        location: "Chennai",
        fees: "₹3,50,000",
        ranking: "Premier Maritime University"
      },
      {
        name: "AMET University",
        location: "Chennai",
        fees: "₹8,00,000",
        ranking: "NAAC A Grade"
      },
      {
        name: "Tolani Maritime Institute",
        location: "Pune",
        fees: "₹12,00,000",
        ranking: "IMO Recognized"
      },
      {
        name: "Marine Engineering and Research Institute",
        location: "Mumbai",
        fees: "₹4,50,000",
        ranking: "Government Institute"
      }
    ],

    skills: [
      "Ship Design and Construction",
      "Marine Propulsion Systems",
      "Naval Architecture",
      "Offshore Engineering",
      "Marine Safety Systems",
      "CAD Software (AutoCAD Marine)",
      "Project Management",
      "Maritime Regulations",
      "Problem Solving",
      "Leadership Skills"
    ],

    futureScope: "Growing opportunities with expanding maritime trade, offshore renewable energy projects, smart shipping technologies, and India's focus on blue economy development.",

    faqs: [
      {
        question: "Do I have to work on ships after graduation?",
        answer: "No, you can work shore-based in shipyards, design offices, ports, oil companies, or marine consulting firms. Sea-going careers are optional but well-paying."
      },
      {
        question: "What is the difference between Marine Engineering and Naval Architecture?",
        answer: "Marine Engineering focuses on ship machinery and systems, while Naval Architecture deals with ship design and structure. Many programs combine both."
      },
      {
        question: "Are there opportunities in offshore industries?",
        answer: "Yes, excellent opportunities in offshore oil & gas, offshore wind farms, and marine renewable energy projects."
      },
      {
        question: "What about government job opportunities?",
        answer: "Good opportunities in Indian Navy, Coast Guard, port authorities, shipping corporations, and maritime regulatory bodies."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEMarineCoursePage;
